import { IonImg, IonSpinner } from '@ionic/react';
import { useCallback } from 'react';
import { selectCoreServerError } from '../../store/core/coreSlice';
import { useAppSelector } from '../../store/hooks';
import logo from '../../theme/assets/logo.webp';

interface Props {
  background?: string;
}

export const LoadingScreen = ({ background = '#c1cad0' }: Props) => {
  const error = useAppSelector(selectCoreServerError);

  const getLoading = useCallback(() => {
    if (error) {
      return (
        <div className="mediumText6 text-center darkText" style={{ whiteSpace: 'pre-wrap' }}>
          {error}
        </div>
      );
    }

    return <IonSpinner name="circular" />;
  }, [error]);

  return (
    <div style={{ ...styles.container, background }}>
      <IonImg src={logo} style={styles.logo} />
      {getLoading()}
    </div>
  );
};

const styles = {
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexFlow: 'column nowrap',
    zIndex: 100,
  },
  logo: {
    width: 250,
    height: 150,
    zIndex: 101,
  },
};
